<template>
  <program-featured-section :program-type="programType"/>
</template>

<script>
import ProgramFeaturedSection from './ProgramFeaturedSection.vue'

export default {
  name: 'CurrentAndUpcomingSemesterPrograms',
  metaInfo: {
    title: 'Programs'
  },
  components: { ProgramFeaturedSection },
  props: ['programType']
}
</script>
